import gql from "graphql-tag";
import { pathGroupFields } from "../path-group/path-group.query";
import { pathFields } from "../path/path.query";

// FIXME: compile to "native" gql when posible
// https://github.com/gajus/babel-plugin-graphql-tag
// thats very sad https://github.com/apollographql/graphql-tag/issues/59
// https://github.com/apollographql/graphql-tag/issues/42
// const query = require('gql/Query.gql');

export const userFields = gql`
  fragment userFields on User {
    id
    activePathId
    clientId
    actionPointsTotal
    firstName
    lastName
    timezone
    imageUrl
    advanceColour
    email
    managerEmails
    accountabilityEmails
    cohortId
    ssoProvider
    isSso
    profileUploadedDay
    managerAddedDay
    userBgColor
    adhocPaths
    userAppName
    userLanguage
    pathGeneratedByKyper
    clientEnabledForKyper
    assignedSeries
    cohortAssignedSeries
    entitledPathIds
    seriesAssignments {
      seriesId
      seriesName
      source
      cohortId
      cohortName
    }
  }
`;


export const pathByEmailFields = gql`
  fragment pathByEmailFields on Path {
   id
   name
   pathDescription
   pathImage
   daysOfTheWeek
   daysOfContent
   starts
   ends
   colours 
   language 
   enabledAttributes  
   enabled
   createdAt
   updatedAt
   clientId
   client {
     id
     name
     tagLine
     imageUrl
     headerFontUrl
     bodyFontUrl
     faqUrl
     tutorialUrl
     enableFoozi
     subDomain
     backgroundImageUrl
     isCohort
     alternateCohortName
   }
  }`
export const pathRegistrationFields = gql`
  fragment pathRegistrationFields on PathRegistration {
    userId
    pathId
    earnedActionPoints
    pathData {
      loginReminderEnabled
      loginReminderTime
      deviceRegistrationId
      emailReminderEnabled
      pushReminderEnabled
      socialReminderEnabled
      socialEmailEnabled
      selectedLearningDay
      loginReminderWeekday
      loginReminderDate
      headingFontSize
      bodyFontSize
    }
    screensViewed
    scheduleDay
    loggedInDates
    selectedDayPart
    userBgColor
  }
`;

export const updateUser = gql`
  mutation updateUser($user: UserInput!) {
    updateUser(userInput: $user) {
      ...userFields
    }
  }
  ${userFields}
`;

export const updatePathRegistration = gql`
  mutation updatePathRegistration($pathRegistration: PathRegistrationInput!) {
    updatePathRegistration(pathRegistrationInput: $pathRegistration) {
      ...pathRegistrationFields
    }
  }
  ${pathRegistrationFields}
`;

export const signUpUser = gql`
  mutation signUpByForm($user: UserInput!) {
    signUpByForm(userInput: $user) {
      user {
        ...userFields
      }
      errors
    }
  }
  ${userFields}
`;

export const pathGroupsByClientEmail = gql`
  query pathGroupsByClientEmail(
    $email: String!
    $clientId: String
    $clientSubDomain: String
    $fromMobile: Boolean
  ) {
    pathGroupsByClientEmail(
      email: $email
      clientId: $clientId
      clientSubDomain: $clientSubDomain
      fromMobile: $fromMobile
    ) {
      pathGroups {
        ...pathGroupFields
      }
      errors
    }
  }
  ${pathGroupFields}
`;

export const pathsByClientEmail = gql`
query pathsByClientEmail($email: String!, $clientId: String, $clientSubDomain: String, $fromMobile: Boolean) {
 pathsByClientEmail(
   email: $email
   clientId: $clientId
   clientSubDomain: $clientSubDomain
   fromMobile: $fromMobile
 ) {
   ...pathByEmailFields
 }
}
 ${pathByEmailFields}
`;

/**
 * Signup discovery, grouped by Series — the counterpart of pathsByClientEmail.
 *
 * Same arguments, so the swap is a drop-in. The response is a wrapper rather than a bare list:
 * `series` carries the groups, `ungroupedPaths` the Cycles in none of them (required, not a
 * convenience — Kyper Cycles have no user_group, and a client with no Series yet would otherwise
 * offer nothing at all), and `errors` is the first place this flow has had a real error field.
 *
 * Both path lists ask for the full signup fragment: the select screens read the description, the
 * image and the client off each Cycle, not just its name.
 */
export const seriesByClientEmail = gql`
  query seriesByClientEmail(
    $email: String!
    $clientId: String
    $clientSubDomain: String
    $fromMobile: Boolean
  ) {
    seriesByClientEmail(
      email: $email
      clientId: $clientId
      clientSubDomain: $clientSubDomain
      fromMobile: $fromMobile
    ) {
      series {
        id
        name
        description
        color
        sortOrder
        paths {
          ...pathByEmailFields
        }
      }
      ungroupedPaths {
        ...pathByEmailFields
      }
      errors
    }
  }
  ${pathByEmailFields}
`;

export const pathsBySignupCode = gql`
  query pathsBySignupCode(
    $signupCode: String!
  ) {
    pathsBySignupCode(
      signupCode: $signupCode
    ) {
      paths {
        id
        name
        # Kyper Cycles have no pathGroup, so the client has to come off the path itself — see
        # sign-up.component, which used to reach through pathGroup and throw for every Kyper path.
        client {
          id
          name
          imageUrl
          backgroundImageUrl
          isCohort
        }
        pathGroup {
          id
          name
          client {
            id
            name
          }
        }
      }
      errors
    }
  }
`;

export const pathGroupsBySignupCode = gql`
  query pathGroupsBySignupCode(
    $signupCode: String!
  ) {
    pathGroupsBySignupCode(
      signupCode: $signupCode
    ) {
      pathGroups {
        ...pathGroupFields
      }
      errors
    }
  }
  ${pathGroupFields}
`;

export const pathGroupsByToken = gql`
  query pathGroupsByToken($token: String!) {
    pathGroupsByToken(token: $token) {
      ...pathGroupFields
    }
  }
  ${pathGroupFields}
`;

export const findUser = gql`
  query findUser($id: Int!) {
    user(id: $id) {
      #    createdAt
      ...userFields
    }
  }
  ${userFields}
`;

export const listUsers = gql`
  query listUsers($email: String!) {
    userEmail(email: $email) {
      ...userFields
      createdAt
    }
  }
  ${userFields}
`;

export const deleteAccount = gql`
mutation deleteAccount($id: Int!) {
 deleteAccount(id: $id) {
    status
  }
}
`


export const screenViewedFields = gql`
  fragment pathRegistrationFields on PathRegistration {
    userId
    pathId
    screensViewed
    scheduleDay
  }
`;


export const updateScreensViewed = gql`
  mutation updatePathRegistration($pathRegistration: PathRegistrationInput!) {
    updatePathRegistration(pathRegistrationInput: $pathRegistration) {
      ...pathRegistrationFields
    }
  }
  ${screenViewedFields}
`;
